export default __webpack_public_path__ + "images/send.f1a3a6bbf760ae64eeba1173c434ccdd.svg";